import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// @ts-ignore: Vite statically replaces import.meta.env.VITE_* at build time
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim();
// @ts-ignore: Vite statically replaces import.meta.env.VITE_* at build time
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim();

export const supabase: SupabaseClient | null = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  })
  : null;

export function hasSupabaseClient(): boolean {
  return supabase !== null;
}
